import * as React from 'react';

import { DialogTrigger } from '@radix-ui/react-dialog';
import { FormattedMessage, useIntl } from 'react-intl';

import { statisticsMessages } from 'src/features/statistics/utils';
import { downloadReceipt, generateCanvas } from 'src/features/statistics/utils/digitalReceipt';
import { ReceiptFont } from 'src/features/statistics/utils/receiptFont';
import { Button } from 'src/registry/ui/Button';
import { generalMessages } from 'src/utils/messages';

import { ViewDigitalReceiptModal } from './ViewDigitalReceiptModal';

import type { ReceiptRow } from 'src/features/statistics/types/receiptRow';

type PaymentDetailsButtonsProps = {
    paymentDate: string;
    digitalReceiptDetails?: string;
    /** Structured rows, where the receipt has them. */
    rows?: ReceiptRow[];
    charsPerLine?: number;
};

const PaymentDetailsButtons = ({
    paymentDate,
    digitalReceiptDetails,
    rows,
    charsPerLine,
}: PaymentDetailsButtonsProps) => {
    const { formatMessage } = useIntl();

    const [isLoadedFont, setIsLoadedFont] = React.useState(false);

    React.useEffect(() => {
        let cancelled = false;
        void ReceiptFont.ready().then(() => {
            if (!cancelled) setIsLoadedFont(true);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    const receiptTextLines = digitalReceiptDetails?.trimEnd().split('\n');
    const fileName = `${formatMessage(generalMessages.smartPark)} ${formatMessage(statisticsMessages.digitalReceipt)} - ${paymentDate}`;

    const handleDownload = () => {
        const canvas = generateCanvas({ lines: receiptTextLines, rows, charsPerLine }, isLoadedFont);
        downloadReceipt(canvas, fileName);
    };
    return (
        <div className="xs:grid-cols-2 grid gap-2">
            <ViewDigitalReceiptModal
                downloadReceipt={handleDownload}
                digitalReceiptDetails={digitalReceiptDetails}
                rows={rows}
                charsPerLine={charsPerLine}
            >
                <DialogTrigger asChild>
                    <Button variant="outline" className="flex-1" disabled={!digitalReceiptDetails}>
                        <FormattedMessage {...statisticsMessages.viewReceipt} />
                    </Button>
                </DialogTrigger>
            </ViewDigitalReceiptModal>
            <Button variant="outline" className="flex-1" onClick={handleDownload} disabled={!digitalReceiptDetails}>
                <FormattedMessage {...statisticsMessages.downloadReceipt} />
            </Button>
        </div>
    );
};

export default PaymentDetailsButtons;
